export default __webpack_public_path__ + "static/media/Troopz.8ca639c5.svg";